export default class Action
{
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...Action.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.DOM.$el.addEventListener('click', this.onClick.bind(this), { passive: true })

        if (this.DOM.$el.querySelector('[role="menu"]')) {
            document.body.addEventListener('click', this.onClickOutside.bind(this), { passive: true })
        }
    }

    onClick() {
        if (!this.DOM.$el.classList.contains(this.options.classNameIsActive)) {
            this.DOM.$el.classList.add(this.options.classNameIsActive)
        } else {
            this.DOM.$el.classList.remove(this.options.classNameIsActive)
        }
    }

    onClickOutside(e) {
        if (!e.target.closest(this.options.selector)) {
            this.DOM.$el.classList.remove(this.options.classNameIsActive)
        }
    }
}

Action.prototype.defaults = {
    classNameIsActive: 'is-active',
    selector: '.js-action',
}